module.exports = __webpack_public_path__ + "img/hero.3d4103af.jpg";